import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  hospital_name: "One Hospitals",
  tagline: "Your health, One destination",
  address: "Plot 123, Health City Road, Hyderabad, Telangana 500001, India",
  phone: "+91 40 1234 5678",
  emergency_phone: "+91 98765 43210",
  whatsapp: "+919876543210",
  email: "contact@onehospitals.com",
  map_embed: "",
  ga_measurement_id: "",
  facebook_url: "",
  instagram_url: "",
  twitter_url: "",
  youtube_url: "",
  linkedin_url: "",
};

const SettingsCtx = createContext(DEFAULTS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings({ ...DEFAULTS, ...r.data })).catch(() => {});
  }, []);

  // Inject Google Analytics when ID is present
  useEffect(() => {
    const id = settings.ga_measurement_id;
    if (!id || typeof window === "undefined") return;
    if (document.getElementById("ga-script")) return;
    const s1 = document.createElement("script");
    s1.id = "ga-script";
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s1);
    const s2 = document.createElement("script");
    s2.id = "ga-inline";
    s2.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${id}');`;
    document.head.appendChild(s2);
  }, [settings.ga_measurement_id]);

  return <SettingsCtx.Provider value={settings}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);

export function digitsOnly(s) { return (s || "").replace(/\D+/g, ""); }
